module.exports = __webpack_public_path__ + "assets/img/smartTV3-icon1.2ad2737a.svg";